import { resolveIconClass, resolveColor, IconElt } from './icon-helpers';

import styles from './styles.less';


function badgeIcon({columns, badgeEncoding}) {


    const iconClass = resolveIconClass({ iconEncoding: badgeEncoding, columns });
    if (!iconClass) {
        return null;
    }

    const icon = IconElt({iconClass, columns,
        shape: badgeEncoding.shape, asText: badgeEncoding.asText, style: badgeEncoding.style, colorEncoding: badgeEncoding.color});
    if (!icon) {
        return null;
    }

    return icon;
}

function badge({name, badgeEncoding, columns, parentSize}) {

    if (!columns || !columns.length) {
        return null;
    }

    const { attribute } = badgeEncoding;
    if (attribute === null || attribute === undefined) {
        return null;
    }

    const icon = badgeIcon({columns, badgeEncoding});
    if (!icon) {
        return null;
    }

    const position = name.match('badge(.*)')[1];
    let translation;
    switch (position) {
        case 'Top':
            translation = `translate3d(0, -${parentSize}px, 0)`;
            break;
        case 'TopLeft': {
            const p = Math.round(0.75 * parentSize);
            translation = `translate3d(-${p}px, -${p}px, 0)`;
            break;
        }
        case 'Left': {
            translation = `translate3d(-${parentSize}px, 0, 0)`;
            break;
        }
        case 'BottomLeft': {
            const p = Math.round(0.75 * parentSize);
            translation = `translate3d(-${p}px, ${p}px, 0)`;
            break;
        }
        case 'Bottom':
            translation = `translate3d(0px, ${parentSize}px, 0)`;
            break;
        case 'BottomRight': {
            const p = Math.round(0.75 * parentSize);
            translation = `translate3d(${p}px, ${p}px, 0)`;
            break;
        }
        case 'Right':
            translation = `translate3d(${parentSize}px, 0, 0)`;
            break;
        case 'TopRight': {
            const p = Math.round(0.75 * parentSize);
            translation = `translate3d(${p}px, -${p}px, 0)`;
            break;
        }
        case 'Cover': 
            translation = '';
            break;
        default:
            //unknown, not worth crashing
            translation = '';
    }

    let border;
    let lineHeight;
    if (badgeEncoding.border && badgeEncoding.border.width) {
        border = {
            'borderWidth': `${badgeEncoding.border.width}px`,
            'borderColor': badgeEncoding.border.color || 'black',
            'borderStyle': badgeEncoding.border.stroke || 'solid'
        };
        lineHeight = {'lineHeight': `${50 - badgeEncoding.border.width}px`};
    } else {
        border = {};
        lineHeight = {};
    }

    let scale;
    const c = position === 'Cover' ? (parentSize || 50) / 50 : (24 / 50.0);
    if (badgeEncoding.dimensions) {
        scale = `scale3d(${
            badgeEncoding.dimensions.maxWidth ? (badgeEncoding.dimensions.maxWidth/50) : c}, ${
            badgeEncoding.dimensions.maxHeight ? (badgeEncoding.dimensions.maxHeight/50) : c}, 1)`;
    } else {
        scale = `scale3d(${c},${c},${c})`;
    }
    const maybeBgColor = badgeEncoding.bg && badgeEncoding.bg.color 
        ? resolveColor({colorEncoding: badgeEncoding.bg.color, columns}) : undefined; 
    const backgroundColor = maybeBgColor != undefined && maybeBgColor != null
        ? {backgroundColor: maybeBgColor} 
        : {};

    const style = {
        ...backgroundColor,
        ...border,
        ...lineHeight,
        ...(badgeEncoding.blendMode ? {'mixBlendMode': badgeEncoding.blendMode} : {}),
        transform: `${ scale } ${ translation /* force hardware acceleration */} ${`perspective(0px)` /* force sub-pixel font rendering when scaled */}`
    };


    return (<div key={name} className={`${styles['badge']} ${styles[position]} ${styles[`shape-${badgeEncoding.shape}`]}`} style={style} >{
        icon
    }</div>);
}


export function badges({badgeEncodings, columns, parentSize}) {
    if (!badgeEncodings || !Object.keys(badgeEncodings).length) {
        return null;
    }
    const badgeElts = 
        Object.entries(badgeEncodings)
            .map(([name, badgeEncoding]) => badge({name, badgeEncoding, columns, parentSize}))
            .filter(v => !!v);

    if (!badgeElts.length) {
        return null;
    }

    return (<div className={styles['badges']}>{ badgeElts }</div>);
}